import script from "./CButtonPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./CButtonPrimary.vue?vue&type=script&setup=true&lang=js"

import "./CButtonPrimary.vue?vue&type=style&index=0&id=32dbd8df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32dbd8df"]])

export default __exports__